import { Injectable } from '@angular/core';
import { OrderEntry } from '@spartacus/cart/base/root';
import { VendorOrderEntryGroup } from '../uig-cart.models';

@Injectable({
    providedIn: 'root',
})

export class UigCartGroupingService {
    RINGFOTO_CODE = 'ringfoto';

    groupByVendor(cartEntries: OrderEntry[], groupSums: any[]): VendorOrderEntryGroup[] {
        let vendorGroups = [];
        if (cartEntries) {
            const uniqueVendorCodes = [...new Set(cartEntries.map(entry => !entry?.product?.vendor?.code ? this.RINGFOTO_CODE: entry?.product?.vendor?.code))];
            uniqueVendorCodes.forEach((vendorCode) => {
                let group: VendorOrderEntryGroup = {};
                let vendorEntries = cartEntries.filter(cartEntry => {
                    if (cartEntry?.product?.vendor?.code === vendorCode) {
                        if (!cartEntry.product.marketplace || vendorCode == this.RINGFOTO_CODE) {
                            group.vendorName = this.RINGFOTO_CODE.toUpperCase();
                            group.noteText = cartEntry.product.vendor?.noteText;
                            group.vendorCode = this.RINGFOTO_CODE;
                        }
                        else {
                            group.vendorName = cartEntry.product.vendor?.name;
                            group.noteText = cartEntry.product.vendor?.noteText;
                            group.vendorCode = cartEntry?.product?.vendor?.code;
                        }
                        return true;
                    }
                    else if(vendorCode == this.RINGFOTO_CODE && !cartEntry?.product?.vendor?.code && !cartEntry.product.marketplace ) {
                            group.vendorName = this.RINGFOTO_CODE.toUpperCase();
                            group.noteText = cartEntry.product.vendor?.noteText;
                            group.vendorCode = this.RINGFOTO_CODE;
                        return true;
                    }
                })
                group.entries = vendorEntries;
                group.quantity = this.calculateGroupQuantity(vendorEntries);
                let currentSum  = groupSums.find(groupSum => groupSum.vendorCode === group.vendorCode);
                group.totalPrice = currentSum?.totalPrice;
                group.deliveryCost = currentSum?.deliveryCost;
                
                vendorGroups.push(group);
            });
        }

        return this.sortGroups(vendorGroups);
    }

    sortGroups(groups: VendorOrderEntryGroup[]): VendorOrderEntryGroup[] {
        return [...groups].sort((a, b) => {
            return a.vendorName === this.RINGFOTO_CODE.toUpperCase() ? -1 : b.vendorName === this.RINGFOTO_CODE.toUpperCase() ? 1 : this.compareString(a.vendorName, b.vendorName);
        })
    }

    compareString = (v1: string, v2: string) => v1.toLowerCase() < v2.toLowerCase() ? -1 : v1.toLowerCase() > v2.toLowerCase() ? 1 : 0;

    calculateGroupQuantity(vendorEntries: OrderEntry[]): number {
        let quantity = 0;
        vendorEntries.forEach(v => { quantity = quantity + v.quantity; });
        return quantity;
    }

}
